import { useSelector } from "react-redux";
import AllowedAccess from "../../Layout/AllowedAccess";
import { Route, Routes } from "react-router-dom";
import ErrorBoundry from "../../Services/ErrorBoundry";
import PageNotFound from "../pageNoFound";
import MastersList from "./MastersList";
import OrgMaster from "./org-master/OrgMaster";
import DivMaster from "./div-master/DivMaster";
import SectorMaster from "./sector-master/SectorMaster";
const MasterRoutes = () => {
	const { userData } = useSelector((state) => state.user);
	return (
		<Routes>
			<Route
				index
				element={
					<AllowedAccess
						role={userData.role_slug} 
              			allowedRoles={["super_admin"]} 
						allowedPermissions={["users_list"]}
						userPermissions={userData.caps_list}
						renderNoAccess={() => <ErrorBoundry />}
						children={<MastersList />}
					/>
				}
			/>
			<Route
				path='organization-master'
				element={
					<AllowedAccess
						role={userData.role_slug} 
              			allowedRoles={["super_admin"]} 
						userPermissions={userData.caps_list}
						renderNoAccess={() => <ErrorBoundry />}
						children={<OrgMaster />}
					/>
				}
			/>
			<Route
				path='division-master'
				element={
					<AllowedAccess
						role={userData.role_slug} 
              			allowedRoles={["super_admin"]} 
                          allowedPermissions={["manage_divisions"]} 
						userPermissions={userData.caps_list}
						renderNoAccess={() => <ErrorBoundry />}
						children={<DivMaster />}
					/>
				}
			/>
			<Route
				path='sector-master'
				element={
					<AllowedAccess
						role={userData.role_slug} 
              			allowedRoles={["super_admin"]} 
                          allowedPermissions={["manage_sectors"]} 
						userPermissions={userData.caps_list}
						renderNoAccess={() => <ErrorBoundry />}
						children={<SectorMaster />}
					/>
				}
			/>
			<Route path="*" element={<PageNotFound />} />
		</Routes>
	);
}

export default MasterRoutes;